import axios from 'axios';
import type { ApiResponse } from '../../../shared/types';

export interface RoomDto {
  RoomID?: number;
  PhongHocID: string;
  TenPhongHoc: string;
  ToaNha?: string;
  MoTa?: string;
}

const API_BASE = '/api/v1/rooms';

export const roomService = {
  async list(params?: { search?: string; page?: number; limit?: number }) {
    const res = await axios.get(API_BASE, { params });
    return res.data as ApiResponse & { data: RoomDto[] };
  },
  async get(id: number) {
    const res = await axios.get(`${API_BASE}/${id}`);
    return res.data as ApiResponse & { data: RoomDto };
  },
  async create(data: RoomDto) {
    const res = await axios.post(API_BASE, data);
    return res.data as ApiResponse;
  },
  async update(id: number, data: RoomDto) {
    const res = await axios.put(`${API_BASE}/${id}`, data);
    return res.data as ApiResponse;
  },
  async remove(id: number) {
    const res = await axios.delete(`${API_BASE}/${id}`);
    return res.data as ApiResponse;
  }
};

export default roomService;


